window.theme = window.theme || {};
theme.WearItWith = (function () {

	var selectors = {
		slider_container: "[data-recent-products-container]",
		slider: "[data-uk-slider-recent]"
	};

	function WearItWith(container) {
		var $container = this.$container = Util.$(container);

		this.$slider_container = Util.$(selectors.slider_container, $container);
		this.$slider = Util.$(selectors.slider, $container);
		this.$entries = [];

		this.productType = Util.data($container, "product-type");
		this.limit = parseInt(Util.data($container, "limit"));

		if (!Util.$('[id^="ProductJson-"]') || this.productType == "Gift Voucher" || this.productType == "Service") {
			this._removeMe();
			return;
		}

		var jsonStr = Util.$('[id^="ProductJson-"]').innerHTML;
		this.currentProduct = JSON.parse(jsonStr);

		this._init();
	}

	WearItWith.prototype = _.assignIn({}, WearItWith.prototype, {

		_init: function () {
			this._setTags();
			this._fetchRelatedProducts();
		},


		_setTags: function () {
			var tags = this.currentProduct.tags;
			this.enamelTag = this._extractTag(tags, "Enamel");
			this.metalTag = this._extractTag(tags, "Metal");
			this.collectionTag = this._extractTag(tags, "Collection");
			this.collectionHandle = this.collectionTag;
		},


		_fetchRelatedProducts: function () {

			/**
			 * &page=N
			 * &type=product
			 * &q=<Phrase> [:TAGS:] [:PRODUCT_TYPE:]
			 */
			var params = [],
				q,
				self = this;

			//Necklace, Necklet and Pendant

			if (this.productType == 'Necklace' || this.productType == "Bangle" || this.productType == "Bracelet" || this.productType == "Pendant") {
				params.push("-product_type:Necklace");
				params.push("-product_type:Bangle");
				params.push("-product_type:Pendant");
				params.push("-product_type:Bracelet");
			} else {
				params.push("-product_type:" + '"' + this.productType + '"');
				if (this.productType == "Ring Set") {
					params.push('-product_type:Ring');
				}
			}

			if (this.collectionTag != "") {
				params.push('tag:"' + encodeURIComponent(this.collectionTag) + '"');
			}

			if (this.metalTag != "") {
				params.push('tag:"' + encodeURIComponent(this.metalTag) + '"');
			}

			if (this.enamelTag != "") {
				params.push('tag:"' + encodeURIComponent(this.enamelTag) + '"');
				params.push("OR -tag:Enamel*");
			}

			if (params.length == 0) {
				return false;
			}

			q = params.join(" ");


			var url = "/search/?view=json&type=product&q=" + q;

			Util.ajax(url, {
				"responseType": "json",
				"headers": { "X-Requested-With": "XMLHttpRequest" }
			}).then(function (xhr) {
				var output = "",
					r = xhr.response;
				if (typeof t === 'string') {
					r = JSON.parse(xhr.response);
				}
				if (r.results_total == 0) {
					return false;
				}
				output = self._render(r);
				Util.after(Util.$(".section-header", self.$container), output);
				Util.removeClass(self.$container, "uk-hidden");
			}).catch(function (e) {
				console.log("ERROR!!! CATCH", e);
			});
		},


		_extractTag: function (tags, tag_prefix) {
			var str = tags.join("|");
			var regex = tag_prefix + '\\-[^\\|]+';
			var re = new RegExp(regex, "g");
			var result = str.match(re);
			return result == null ? "" : result[0];
		},


		/**
		 * @todo Implement me
		 * @param {*} tag_prefix
		 */
		_extractTags: function (tags, tag_prefix) {
			var str = tags.join("|");
			return tags;
		},


		_render: function (r) {

			var items = "";
			for (var index = 0; index < this.limit && index < r.results_total; index++) {
				items += '<li>' + theme.Utility.renderProduct(r.results[index]) + '</li>';
			}

			return [
				'<div data-uk-slider>',
				'<div class="uk-position-relative">',
				'<div class="uk-slider-container">',
				'<ul class="uk-slider-items uk-grid-xsmall uk-grid uk-child-width-1-2@s uk-child-width-1-4@l uk-grid-match">',
				items,
				'</ul>',
				'</div>',
				'<div class="uk-margin-top uk-slider-arrows">',
				'<a aria-label="Previous" class="uk-position-center-left-out" href="#" data-uk-slidenav-previous data-uk-slider-item="previous"></a>',
				'<a aria-label="Next" class="uk-position-center-right-out" href="#" data-uk-slidenav-next data-uk-slider-item="next"></a>',
				'</div>',
				'</div>',
				'<ul class="uk-slider-nav uk-dotnav uk-flex-center uk-margin"></ul>',
				'</div>',
			].join("");
		},


		_removeMe: function () {
			Util.remove(this.$container);
		}
	});
	return WearItWith; 
})();
